import * as React from "react";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

export interface PropertyBexApiComponentProps {
  inputs: {
    propertyId: string;
  };
}

interface PropertyBexApiWrapperProps {
  context: ExtendedContextStore;
  additionalInputs?: object;
}

/**
 * Used to wrap Shared UI or Bex API components relevant to Properties.
 *
 * See PropertyReviewsWrapper or PropertyReviewsHeadline for example.
 * @param Component
 * @param options
 * @constructor
 */
export const PropertyBexApiWrapper = <P extends { inputs: any }>(
  WrappedComponent: React.FC<P & PropertyBexApiComponentProps>
) => {
  // @ts-ignore
  const Component: React.FC<Omit<P, "inputs"> & PropertyBexApiWrapperProps> = ({
    context,
    additionalInputs,
    ...props
  }) => {
    if (context?.searchContext?.location?.type !== "hotel") {
      return null;
    }

    const inputs = {
      propertyId: String(context.searchContext.location.id),
      ...additionalInputs,
    };

    // @ts-ignore
    return <WrappedComponent inputs={inputs} {...props} />;
  };

  return Component;
};
